import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslatePipe } from '@ngx-translate/core';
import { Observable, of, throwError, timer } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';
import { SessionStorageCacheService } from '@shared/services/cache/sessionstorage-cache.service';
import { UrlConfig } from '@shared/config/url.config';

export class CustomTranslateLoader implements TranslateLoader {
  private cacheKeyPrefix = 'translations-'; // Use a prefix to differentiate keys

  constructor(private http: HttpClient, private cacheService: SessionStorageCacheService) { }

  getTranslation(lang: string): Observable<any> {
    const cacheKey = `${this.cacheKeyPrefix}${lang}`;
    const cachedTranslation = this.cacheService.getItem<any>(cacheKey);

    if (cachedTranslation) {
      // Return cached data as observable
      return of(cachedTranslation);
    }

    return this.http.get<any>(`${UrlConfig.urlAdmin}translation/search?locale=${lang}`).pipe(
      tap(data => this.cacheService.setItem(cacheKey, data)), // Cache the data
      retry({
        count: 5,
        delay: (error, retryCount) => {
          if (retryCount <= 5) {
            const delayTime = retryCount * 10000; // 10 seconds for first retry, 20 seconds for second retry, etc.
            console.log(`Retrying after ${delayTime / 1000} seconds. Attempt #${retryCount}`);
            return timer(delayTime);
          } else {
            console.error('Max retry attempts reached. Circuit breaker is now open.');
            return throwError(() => new Error('Max retry attempts reached. Please try again later.'));
          }
        }
      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: any): Observable<never> {
    console.error('An error occurred while fetching translations:', error);
    return throwError(() => new Error('An error occurred while fetching translations. Please try again later.'));
  }
}
